import * as React from "react";
import { SVGProps } from "react";
const SvgNotificationOutline = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 32 32" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M25 6H7c-2.2 0-4 1.8-4 4v12c0 2.2 1.8 4 4 4h18c2.2 0 4-1.8 4-4V10c0-2.2-1.8-4-4-4ZM7 8h18c.7 0 1.3.3 1.7.9-3.4 3.6-6.8 6.3-10.7 8.7-3.8-2.4-7.2-5.2-10.7-8.7a1.95 1.95 0 0 1 1.527-.894L7 8Zm18 16H7c-1.1 0-2-.9-2-2V11.4c3.2 3.2 6.4 5.7 9.9 7.9.3.2.7.3 1.1.3.4 0 .7-.1 1.1-.3 3.6-2.2 6.8-4.8 9.9-7.9V22c0 1.1-.9 2-2 2Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgNotificationOutline;
